import React, { useEffect, useState } from 'react'
import PageHeader from '../../Components/PageHeader/PageHeader'
import AddCash from './AddCash'
import { ApiHit } from '../../Api/ApiHit';
import { searchCashRecord } from '../../Constant/Constant';
import { useDispatch, useSelector } from 'react-redux';
import { setApiJson } from '../../Redux/Actions/ApiAction';

function CashMaster() {
  const [isEditMode, setIsEditMode] = useState(false);
  const ApiReducer = useSelector((state) => state.ApiReducer);
  console.log("ApiReducer", ApiReducer);



  const getUrl = window.location.pathname
  const url = window.location.pathname;
  const urlId = url.split('/')[3];
  const dispatch = useDispatch()

  let title = 'Cashbook Management'
  let description = 'Track, view, and manage all business cash transactions efficiently'
  let cashMethod = null

  useEffect(() => {
    if (urlId) {
      setIsEditMode(true);
      loadCashData();
    } else {
      // Clear the Redux state when not in edit mode
      setIsEditMode(false);
      dispatch(setApiJson({}));
    }
  }, [urlId])

  const loadCashData = () => {
    let json = {
      page: 1,
      limit: 1,
      search: {
        _id: urlId
      }
    }
    ApiHit(json, searchCashRecord).then((res) => {
      console.log("res_____", res);
      if (res?.statusCode === 200) {
        const cashData = res?.data?.docs?.[0];
        console.log("Loaded cash data:", cashData);
        console.log("Date type:", typeof cashData?.date, "Value:", cashData?.date);
        dispatch(setApiJson(cashData))
      }

    })
  }

  // Determine cashMethod based on URL first (highest priority)
  if (getUrl.includes('/cashbook/cashIn')) {
    title = 'Cash In'
    description = 'Record and manage all incoming cash transactions efficiently'
    cashMethod = 'cashIn'
  } else if (getUrl.includes('/cashbook/cashOut')) {
    title = 'Cash Out'
    description = 'Record and manage all outgoing cash transactions efficiently'
    cashMethod = 'cashOut'
  }
  // Only check ApiReducer if in edit mode and URL doesn't specify the type
  else if (isEditMode && Object.keys(ApiReducer?.apiJson).length !== 0) {
    if (ApiReducer?.apiJson?.cashMethod === "cashOut") {
      title = 'Cash Out'
      description = 'Record and manage all outgoing cash transactions efficiently'
      cashMethod = 'cashOut'
    }
    else if (ApiReducer?.apiJson?.cashMethod === "cashIn") {
      title = 'Cash In'
      description = 'Record and manage all incoming cash transactions efficiently'
      cashMethod = 'cashIn'
    }
  }

  console.log("Current URL:", getUrl, "→ cashMethod:", cashMethod)

  return (
    <div>
      <PageHeader
        title={title}
        description={description}
      />
      <AddCash cashMethod={cashMethod} isEditMode={isEditMode} />
    </div>
  )
}

export default CashMaster
